import { modules } from 'veritone-redux-common';
const {
  config: { getConfig }
} = modules;

const getApiRoot = state => {
  const config = getConfig(state);
  return config.apiRoot;
};

export default getApiRoot;
